module.exports = __webpack_public_path__ + "img/under-maintenance-dark.c36582d1.svg";